
































import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
import { store } from "@/store/store";
import { DeviceActionsTypes } from "@/store/modules/Device/types";
import { ApiResponse } from "@/types/types";

export default Vue.extend({
  name: "DeviceDeleteModal",
  components: { Modal, Paragraph },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    onValidate: {
      type: Function,
      default: () => undefined
    },
    onAction: {
      type: Function,
      default: () => undefined
    },
    devices: {
      type: Array as () => Array<string>
    }
  },
  data: () => {
    return {
      title: "Supprimer l'appareil",
      loading: false
    };
  },
  methods: {
    async onDelete(ids: string[]): Promise<boolean> {
      const names = ids.map((id) => store.getters.DEVICE_BY_ID[id].material_name);
      const results = await Promise.all(names.map((id) => store.dispatch(DeviceActionsTypes.ARCHIVE_DEVICE, id)));
      return results.every((response) => response === ApiResponse.SUCCESS);
    },
    findNameById(id: string): string {
      return store.getters.DEVICE_BY_ID[id].material_name || "";
    },
    async onClickHandler(): Promise<void> {
      this.loading = true;
      const success = await this.onDelete(this.devices);
      this.loading = false;
      if (success) {
        this.onAction({
          type: "SUCCESS",
          title: "Suppression",
          content: "Les appareils ont bien été supprimés."
        });
        this.onClose();
      } else {
        this.loading = false;
        this.onAction({
          type: "ERROR",
          title: "Suppression",
          content: `Une erreur s'est produite lors de la suppression`
        });
      }
    }
  }
});
